/**
 *
 * Question
 *
 */

export const FixBlankAvatarMixin = {
  name: 'FixBlankAvatarMixin',

  filters: {
    fixBlankAvatar: (v) => {
      return !v || -1 !== v.search('undefined') ? '/img/photos/avatar.png' : v;
    },
  },
};
